const breakpoints = {
	mobileS: '320px',
	mobileL: '480px',
	tabletMinus: '767px',
	tabletH: '781px',
	tablet: '768px',
	tabletL: '992px',
	laptop: '1024px',
	laptopH: '1080px',
	laptopXS: '1110px',
	laptopS: '1280px',
	laptopM: '1366px',
	laptopL: '1440px',
	laptopXL: '1540px',
	desktopS: '1800px',
	desktop: '2560px'
};
export const devices = {
	fold: `@media only screen and (max-width: ${breakpoints.mobileS})`,
	phoneXs: `@media only screen and (max-width: ${breakpoints.mobileL})`,
	phone: `@media only screen and (max-width: ${breakpoints.tabletMinus})`,
	phoneLandscape: `@media only screen and (max-width: ${breakpoints.mobileL})`,
	tabletOnly: `@media only screen and (min-width: ${breakpoints.tablet})  and (max-width: ${breakpoints.tabletL})`,
	iPadProLandscape: `@media only screen and (height: ${breakpoints.laptop}) and (width: ${breakpoints.laptopM})`,
	iPadProPortrait: `@media only screen and (max-width: ${breakpoints.laptop}) and (max-height: ${breakpoints.laptopM})`,
	iPad: `@media only screen and (max-width: ${breakpoints.laptop}) and (max-height: ${breakpoints.tablet}) `,
	tablet: `@media only screen and (max-width: ${breakpoints.tabletL}) `,
	desktop: `@media only screen and (min-height: ${breakpoints.tabletH} ) and (min-width: ${breakpoints.laptopS} ) `,
	laptop: `@media only screen and (max-width: ${breakpoints.laptopS}) `,
	laptopRegularScreenWidth: `@media only screen (max-height: ${breakpoints.laptopXS}) and and (max-width: ${breakpoints.laptopXL}) `,
	bigDesktop: `@media only screen and (min-width: ${breakpoints.desktopS}) and (min-height: ${breakpoints.laptopH})) `
};
